import React from "react";
import TicketStatus from "shared/enums/TicketStatus";
import { AlertModalType } from "shared/components/alertModal/type";
import { ApiInvoicePaymentRequestBasic } from "shared/types/ApiInvoicePaymentRequestBasic";

export enum Action {
  SET_ALERT_CONFIG = "SET_ALERT_CONFIG",
  OPEN_ASSIGN_TICKET_MODAL = "OPEN_ASSIGN_TICKET_MODAL",
  OPEN_BUY_MORE_TICKET_MODAL = "OPEN_BUY_MORE_TICKET_MODAL"
}

export interface State {
  alertConfig?: AlertModalType;
  openAssignTicket?: boolean;
  openBuyMoreTicket?: boolean;
}

export interface ReducerDispatch {
  setAlertConfig: (data?: AlertModalType) => void;
  setAssignTicketModal: (data: boolean) => void;
  setBuyMoreTicket: (data: boolean) => void;
}

export type ActionType =
  | {
      type: Action.SET_ALERT_CONFIG;
      data?: AlertModalType;
    }
  | {
      type: Action.OPEN_ASSIGN_TICKET_MODAL;
      data: boolean;
    }
  | {
      type: Action.OPEN_BUY_MORE_TICKET_MODAL;
      data: boolean;
    };

export interface ApiBulkTicket {
  id: string;
  valid: boolean;
  ticketsPurchased: number;
  assignedTickets?: AssignedTicket[];
  forwardedToInvoicePayer?: boolean;
  invoicePaymentRequest?: ApiInvoicePaymentRequestBasic;
  ticketFormName: string;
  ticketFormId: string;
  purchasedOn: string;
  transfers: Array<ApiBulkTicketTransferResponse>;
}

interface ApiBulkTicketTransferResponse {
  id: string;
  fromName: string;
  toName: string;
  consoleUserName: string;
  bulkTicketId: string;
}

export interface AssignedTicket {
  id: string;
  registrationParticipantId: string;
  valid: boolean;
  name: string;
  workEmail: string;
  ticketStatus: TicketStatus;
  ticketFormName: string;
  uiVersion: number;
}

export interface TicketPurchaseSummary {
  total: number;
  unassigned: number;
  pending: number;
  registered: number;
}

export interface BulkTicketSummaryProps {
  bulkTickets: Array<ApiBulkTicket>;
}

type RevokeTicketHandlerFunction = (
  ticketId: string,
  isTicketAssignmentPending: boolean,
  uiVersion: number,
  isLoggedInUser: boolean
) => void;

export interface BulkTicketTableProps {
  list: Array<AssignedTicket>;
  revokeTicketHandler: RevokeTicketHandlerFunction;
  tableRef: React.MutableRefObject<any>;
  noRecordMessage?: string;
}

export interface BulkTicketManageService {
  state: State;
  refetch: () => void;
  revokeTicketHandler: RevokeTicketHandlerFunction;
  purchaseSummary: TicketPurchaseSummary;
  openAssignModalHandler: (ticketFormId: string) => void;
  closeAssignModalHandler: () => void;
  openBuyMoreModalHandler: (ticketFormId: string) => void;
  closeBuyMoreModalHandler: () => void;
  assignedTicketList: Array<AssignedTicket>;
  noRecordMessage?: string;
  bulkTicketForms: Array<any>;
  selectedTicketFormId: string;
  data: ApiBulkTicket[];
  openTransferModalHandler: () => void;
  closeTransferModalHandler: () => void;
  isTransferModalOpen: boolean;
  registrationParticipantId: string;
  hasValidBulkTicketPurchases: boolean;
  selectedTicketFormNameByTicketFormId: string;
  selectedTicketFormNameByBulkTicketId: string;
  selectedBulkTicketId: string;
  paymentPendingInventoryForms: PaymentPendingInventoryFormsType;
}

interface PaymentPendingInventoryFormsType {
  invoicePending: Array<string>;
  offlinePending: Array<string>;
}

interface BulkTicketManagementProps {
  isOpenInModal?: boolean;
  modalCloseHandler?: () => void;
}
